import { useAppContext } from '../contexts/AppContext';

export default () => useAppContext();
